module.exports = __webpack_public_path__ + "9631aae522d7a8ffce718361f0fa7faa.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-40.svg
// module id = 577
// module chunks = 0